import apiHelper from '@/utils/apiHelper';

const checkCompsetName = async (name) => {
  const { data } = await apiHelper(
    'GET',
    `/check-compset-name/${name}`,
  );

  return !data.data.exists;
};

export default checkCompsetName;
